import shared from "@lab/store/lists.shared.module";
import { users as api } from "@/api/user.api";
import Bugsnag from "@/utils/bugsnag";
import { userroles } from "@lab/meta/users";

const state = {
	...shared.state
};

const getters = {
	...shared.getters,
	userroles: (_) => userroles
};

const actions = {
	...shared.actions,
	async fetch({ commit, dispatch }) {
		commit("LOAD_START");

		const _users = await api.fetch().catch((error) => {
			Bugsnag.notify(
				new Error(`Super users fetch: ${error.response.data.error}`)
			);
		});

		if (_users) {
			return dispatch(`prepare`, _users);
		}

		commit(`LOAD_FINISH`);
	},
	prepare({ commit }, users) {
		commit(`LOAD_LIST_SUCCESS`, users);
	}
};

const mutations = {
	...shared.mutations
};

export default { namespaced: true, state, getters, actions, mutations };
